import { useState, useEffect, useRef } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Projects from "./components/Projects/Projects";
import Skills from "./components/Skills/Skills";
import Contact from "./components/Contact/Contact";
import Footer from "./components/Footer/Footer";
import { motion, useViewportScroll, useTransform } from "framer-motion";
import NotFound from "./components/NotFound/NotFound";
import ProjectDetails from "./components/Projects/ProjectDetails";


function App() {
  const [transparent, setTransparent] = useState(true);
  const [opacity, setOpacity] = useState(1);
  const navbarRef = useRef(null);
  const { scrollYProgress } = useViewportScroll();
  const progress = useTransform(scrollYProgress, [0, 1], [0, 1900]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setTransparent(false);
        setOpacity(0.8);
      } else {
        setTransparent(true);
        setOpacity(1);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <BrowserRouter>
      <div className="bg-stone-950 min-h-screen">
        <Navbar ref={navbarRef} transparent={transparent} opacity={opacity} />
        <div style={{ paddingTop: "40px" }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/skills" element={<Skills />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/projects/:id" element={<ProjectDetails />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
        <Footer />
        <motion.div
          className="h-2 bg-green-400 rounded-full fixed top-11 left-0 right-0"
          style={{ marginTop: "20px", width: progress }}
        />
      </div>
    </BrowserRouter>
  );
}

export default App;